import React, { createContext, useContext, useState, useEffect } from 'react';
// Create the context with a default value
var PortalContainerContext = createContext(undefined);
// Create a custom hook for easy consumption
export var usePortalContainer = function () {
    var context = useContext(PortalContainerContext);
    if (context === undefined) {
        throw new Error('usePortalContainer must be used within a PortalContainerProvider');
    }
    return context;
};
// Create the provider component
export var PortalContainerProvider = function (_a) {
    var children = _a.children, _b = _a.containerId, containerId = _b === void 0 ? '.harmony-app' : _b;
    var _c = useState(null), portalContainer = _c[0], setPortalContainer = _c[1];
    useEffect(function () {
        // Find the container element only on the client-side after mount
        if (typeof document !== 'undefined') {
            var element = document.querySelector(containerId);
            if (element) {
                setPortalContainer(element);
            }
            else {
                console.error("Portal container '#".concat(containerId, "' not found."));
                // Decide how to handle missing container - maybe provide document.body as fallback?
                // For now, setting it to null. Consumers should check for null.
            }
        }
    }, [containerId]); // Re-run if containerId changes
    // Memoize the context value to prevent unnecessary re-renders
    var value = React.useMemo(function () { return ({ portalContainer: portalContainer }); }, [portalContainer]);
    return (React.createElement(PortalContainerContext.Provider, { value: value }, children));
};
